export default __webpack_public_path__ + "static/media/login-step-active.1dd8988e.svg";